import { setUploaderConfigAction as setUploaderConfigOperation } from 'editor/src/store/editor/slice';

export default setUploaderConfigOperation;
